import React, { Component } from 'react'
import Included from '../Included'
class Tooltips extends Component {

  constructor(props) {
    super(props)
  }

  render (){
    return(
    <section><a className="anchor"id="tooltips"></a>
      <h2>Tooltips</h2>
      <p>Hover over this <abbr data-toggle="tooltip" rel="tooltip" title="Lorem ipsum dolor sit amet, consectetur adipiscing elit.">text</abbr> to view a tooltip</p>
      <pre><code className="language-html">{`<p>Hover over this <abbr rel="tooltip" title="I am a tooltip">text</abbr> to view a tooltip</p>`}</code></pre>
      <br/>
      <h3>Tooltips Styles</h3>
      <p>Hover on this text styles&nbsp;&nbsp;<abbr rel="tooltip" className="tooltip-selector--light" title="Lorem ipsum dolor sit amet, consectetur adipiscing elit.">light</abbr>,&nbsp;&nbsp;&nbsp;
        <abbr rel="tooltip" className="tooltip-selector--alternative" title="Lorem ipsum dolor sit amet, consectetur adipiscing elit.">alternative</abbr>&nbsp;&nbsp;and&nbsp;&nbsp;
        <abbr rel="tooltip" className="tooltip-selector--white" title="Lorem ipsum dolor sit amet, consectetur adipiscing elit.">white</abbr>
      </p>
      <pre><code className="language-html">{`<p>Hover over this text styles
        <abbr rel="tooltip" className="tooltip-selector--light" title="Lorem ipsum dolor sit amet, consectetur adipiscing elit.">light</abbr>,
        <abbr rel="tooltip" className="tooltip-selector--alternative" title="Lorem ipsum dolor sit amet, consectetur adipiscing elit.">alternative</abbr> and
        <abbr rel="tooltip" className="tooltip-selector--white" title="Lorem ipsum dolor sit amet, consectetur adipiscing elit."> white</abbr></p>`}</code></pre>
      <br/>
      {/* <p>The tooltip arrow will automatically adjust its hanging arrow to fit correctly. It responds to touch events and is mobile friendly.</p> */}
      <pre><code className="language-javascript">{`
// Using default attributes shown in snippet.
// The library looks for the an abbr with the attribute rel='tooltip' by default.
commonUI.initializeTooltip();

// You can have multiple tooltips on the page, they will all be initialised.

// The element must have a 'title' attribute with the text to be used in the tooltip.

// Using a custom selector
//commonUI.initializeTooltip({selector:'a[rel="custom-property"]'});
commonUI.initializeTooltip({selector:'.tooltip-selector--light'});

// Applying the light theme
commonUI.initializeTooltip({
  selector:'.tooltip-selector--light',
  theme: 'light'
});
      `}</code></pre>
    <br/>
    <hr/>
    </section>
  )
}
}

export default Tooltips



// WEBPACK FOOTER //
// ./styleguide/components/sections/Tooltips.js